/**
 * en-GB messages for the Phase 4 kiosk parity gaps (spec section 2). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const gapKioskEnGB = {
    'kiosk.finish.poweredBy': 'Powered by CloudSign',
    'kiosk.badge.noMedia': 'The badge printer has no labels loaded. You are signed in. Please tell reception.',
    'kiosk.badge.mediaMismatch': 'The badge printer has the wrong labels loaded. You are signed in. Please tell reception.',
    'kiosk.badge.coverOpen': 'The badge printer cover is open. You are signed in. Please tell reception.',
    'kiosk.member.menuTitle': 'What would you like to do?',
    'kiosk.member.signIn': 'Sign me in',
    'kiosk.member.updatePhoto': 'Update my photo',
    'kiosk.member.sendInvite': 'Send me the app invite',
    'kiosk.memberPhoto.title': 'Update your photo',
    'kiosk.memberPhoto.saved': 'Your photo has been updated.',
    'kiosk.memberPhoto.failed': 'Your photo could not be saved. Please try again, or ask at reception.',
    'kiosk.memberPhoto.offline': 'This kiosk is offline, so your photo cannot be updated right now.',
    'kiosk.memberPhoto.notAllowed': 'Your photo cannot be updated at the kiosk. Please ask at reception.',
    'kiosk.invite.title': 'Get the CloudSign app',
    'kiosk.invite.sent': 'We have emailed you a link to set up the app. Please check your inbox.',
    'kiosk.invite.noEmail': 'We have no email address for you, so we could not send an invite. Please ask at reception.',
    'kiosk.invite.tooMany': 'You have asked for too many invites today. Please try again tomorrow.',
    'kiosk.invite.failed': 'The invite could not be sent. Please try again, or ask at reception.',
    'kiosk.invite.offline': 'This kiosk is offline, so an invite cannot be sent right now.',
    'kiosk.invite.sending': 'Sending your invite…',
};
//# sourceMappingURL=gap-kiosk.js.map